import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import './screen-modal.scss';
var prefixCls = 'screen-modal';
var ScreenModal = function (props) {
    var onVisibleChange = props.onVisibleChange, values = props.values;
    var handleClick = useCallback(function () {
        typeof onVisibleChange === 'function' && onVisibleChange(false);
    }, [onVisibleChange]);
    var _a = useState(values.timer || 10), time = _a[0], setSeconds = _a[1];
    useEffect(function () {
        var timer = setInterval(function () {
            setSeconds(function (t) {
                return t - 1;
            });
        }, 1000);
        return function () {
            clearInterval(timer);
        };
    }, [handleClick]);
    useLayoutEffect(function () {
        if (time === 0) {
            handleClick();
        }
    }, [time, handleClick]);
    return (React.createElement("div", { className: "screen-modal-container" },
        React.createElement("div", { className: "modal-mark" }),
        React.createElement("div", { className: prefixCls + " pub_container" },
            React.createElement("div", { className: "close_pub" },
                React.createElement("span", { className: "countdown" }, time + "\u79D2\u540E\u5173\u95ED"),
                React.createElement("span", { className: "close-button", onClick: handleClick },
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", style: { width: 24, height: 24 } },
                        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" })))),
            React.createElement("div", { className: "mask_content" },
                React.createElement("img", { src: "" + values.bg, alt: "" })))));
};
export default React.memo(ScreenModal);
